// extracted by mini-css-extract-plugin
module.exports = {"container":"homeSSO_container__2TXWC","card":"homeSSO_card__1GPBJ","card__img":"homeSSO_card__img__v0kik","card__title":"homeSSO_card__title__1mHLr"};